import React, { useState } from "react";

const Alert = ({title, message, color}) => {
    const [closed, SetClosed] = useState(false);
    let alertColor = 'bg-primary';
    switch(color)
    {
        case 'danger': alertColor = 'bg-danger'; break;
        case 'success': alertColor = 'bg-success'; break;
        case 'warning': alertColor = 'bg-warning'; break;
        default: alertColor = 'bg-info'; break;
    }
    return(
        <React.Fragment>
        {closed ? null :
        <div className={"alert "+ alertColor}>
            <div className="flex justify-between">
                <strong>{title}</strong>
                <i className="fa fa-times cursor-pointer" onClick={() => SetClosed(true)}></i>
            </div>
            <div className="leading-8 text-sm">{message}</div>
        </div>
        }
        </React.Fragment>
    )
}

export default Alert;